import { useEffect } from 'react';

// El panel de Talento Humano (backend + /admin) vive en un dominio aparte
// (panel.5igsolutions.com), no en este sitio publico. En local, donde el
// mismo servidor Express sirve todo, esta variable queda vacia y el atajo
// sigue yendo a la ruta relativa de siempre.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Atajo secreto para llegar al login del panel de Talento Humano sin tener
// que escribir /admin en la barra de direcciones: Ctrl+Alt+L en cualquier
// pagina publica del sitio. No aparece en ningun link ni boton visible.
const AdminShortcut = () => {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 'l') {
        e.preventDefault();
        window.location.href = `${API_BASE_URL}/admin/login`;
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return null;
};

export default AdminShortcut;
